<template>
  <div class="authority">
    <div class="header">
      <div class="title">权威认证</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list" ref="all">
        <div
          class="item"
          v-for="item in authorityList"
          :key="item.id"
          ref="demoItem"
          :style="'transform: translateX(' + item.translateNum + 'px)'"
        >
          <img :src="item.logo" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import authorityLogo1 from "../../../assets/about/authorityLogo1.png";
import authorityLogo2 from "../../../assets/about/authorityLogo2.png";
import authorityLogo3 from "../../../assets/about/authorityLogo3.png";
import authorityLogo4 from "../../../assets/about/authorityLogo4.png";
import authorityLogo5 from "../../../assets/about/authorityLogo5.png";
import authorityLogo6 from "../../../assets/about/authorityLogo6.png";
import authorityLogo7 from "../../../assets/about/authorityLogo7.png";
import authorityLogo8 from "../../../assets/about/authorityLogo8.png";
import authorityLogo9 from "../../../assets/about/authorityLogo9.png";
import authorityLogo10 from "../../../assets/about/authorityLogo10.png";
import authorityLogo11 from "../../../assets/about/authorityLogo11.png";
import authorityLogo12 from "../../../assets/about/authorityLogo12.png";
import authorityLogo13 from "../../../assets/about/authorityLogo13.png";
import authorityLogo14 from "../../../assets/about/authorityLogo14.png";
import authorityLogo15 from "../../../assets/about/authorityLogo15.png";
import authorityLogo16 from "../../../assets/about/authorityLogo16.png";
import authorityLogo17 from "../../../assets/about/authorityLogo17.png";

export default {
  setup() {
    return reactive({
      authorityList: [
        {
          id: 1,
          logo: authorityLogo1,
        },
        {
          id: 2,
          logo: authorityLogo2,
        },
        {
          id: 3,
          logo: authorityLogo3,
        },
        {
          id: 4,
          logo: authorityLogo4,
        },
        {
          id: 5,
          logo: authorityLogo5,
        },
        {
          id: 6,
          logo: authorityLogo6,
        },
        {
          id: 7,
          logo: authorityLogo7,
        },
        {
          id: 8,
          logo: authorityLogo8,
        },
        {
          id: 9,
          logo: authorityLogo9,
        },
        {
          id: 10,
          logo: authorityLogo10,
        },
        {
          id: 11,
          logo: authorityLogo11,
        },
        {
          id: 12,
          logo: authorityLogo12,
        },
        {
          id: 13,
          logo: authorityLogo13,
        },
        {
          id: 14,
          logo: authorityLogo14,
        },
        {
          id: 15,
          logo: authorityLogo15,
        },
        {
          id: 16,
          logo: authorityLogo16,
        },
        {
          id: 17,
          logo: authorityLogo17,
        },
      ],
      translateNum: 0,
      timer: null,
    });
  },
  mounted() {
    this.search();
  },
  beforeUnmount() {
    window.clearInterval(this.timer);
  },
  methods: {
    search() {
      // 循环给tableData数组每一个对象添加translateNum属性为0，这也是为了方便记录每一个对象滚动的宽度
      for (let i = 0; i < this.authorityList.length; i++) {
        this.authorityList[i].translateNum = 0;
      }

      // 在元素完全渲染后再循环给每一个对象添加indexLeft属性，记录此对象初始位置，方便滚动超出父元素边界后，重新设置元素位置
      this.$nextTick(() => {
        for (let j = 0; j < this.authorityList.length; j++) {
          this.authorityList[j].indexLeft = this.$refs.demoItem[j].offsetLeft;
        }

        // 调用滚动定时器
        this.roll();
      });
    },
    roll() {
      this.timer = setInterval(() => {
        // 循环给每一个对象修改translateNum属性值，从而动态修改页面元素的transform样式，达到滚动的效果
        for (let i = 0; i < this.authorityList.length; i++) {
          /**
           * 判断此元素是否即将超出父级元素carousel-item的显示区域
           * 1400 = 父级元素carousel的宽度 + 一个子元素carousel-item的宽度（如果元素有间距也需要带上）即 1200 + 180 + 20(间距)
           * 修改父级元素与子元素样式时需要留意此处也应当一起修改
           */
          if (
            17 * 210 -
              this.authorityList[i].translateNum -
              this.authorityList[i].indexLeft <
            0
          ) {
            /**
             * 如果超出，则将元素移动至父级元素显示区域的左方
             * 此处的200 对应着子元素carousel-item的样式宽度
             */
            this.authorityList[i].translateNum =
              this.$refs.all.offsetLeft - this.authorityList[i].indexLeft - 180;
          }

          // 设置每个元素每次滚动的像素大小，像素越小越平滑,这里每次只移动一个像素
          this.authorityList[i].translateNum =
            this.authorityList[i].translateNum + 1;
        }
      }, 1); // 30毫秒滚动一次，时间间隔越短滚动越平滑
    },
  },
};
</script>

<style scoped>
.authority {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  width: 1180px;
  display: flex;
  align-items: center;
  justify-content: left;
  overflow: hidden;
}
.body .list .item img {
  width: 180px;
  margin-right: 20px;
}
</style>
